import React from "react";
import defaultUserIcon from "../../../images/user.png";
import styles from "./ProfileAvatar.module.css";

// Avatar circular del perfil. Sin `src` muestra el icono de usuario por defecto;
// cuando existan fotos de perfil basta con pasar la URL en `src`.
const ProfileAvatar = ({ src, alt = "Foto de perfil" }) => (
  <div className={src ? styles.avatar : `${styles.avatar} ${styles.avatarDefault}`}>
    <img src={src || defaultUserIcon} alt={alt} />
  </div>
);

export default ProfileAvatar;
